import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';

export const bgRangeClass = input => {
    const eatCode = get(input, 'tags.eat_code') || -1;
    const bgValue = get(input, 'value');

    // no more calculation in case the value is missing
    if (isUndefined(bgValue)) return '';

    // before eating in range is [70, 130]
    // the rest should be in [70, 180]
    // before eating slightly high [131, 180]
    const upperLimit = 180;
    const lowerLimit = 70;
    const slightlyHighLimit = 130;

    // determination BG range
    if (bgValue < lowerLimit || bgValue > upperLimit) {
        return 'bg-below-range';
    } else if (
        bgValue > slightlyHighLimit &&
        bgValue <= upperLimit &&
        eatCode >= 6 &&
        eatCode <= 8 &&
        eatCode !== 13 &&
        eatCode !== -1
    ) {
        return 'bg-above-range';
    }

    return 'bg-in-range';
};
